
/**
 * config
 * @param Vue Vue构造函数
 * @param option
 */
function install(Vue,option){
  //全局实例方法
  Vue.prototype.$config = {
    host:'',
    leemmaCustomer:'https://customers.leemma.com',

  }

}

export default install;



// WEBPACK FOOTER //
// ./src/assets/lib/config.js